/// <reference path="references.ts" />
var PageHomeEntryForm = /** @class */ (function () {
    //Variables
    //Methods
    function PageHomeEntryForm() {
        var thisObj = this;
        //console.log('Root URL: ' + ApfcoRootUrl);
        //this.SleepTest();
    }
    return PageHomeEntryForm;
}());
//# sourceMappingURL=PageHomeEntryForm.js.map